import { Component, AfterViewInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";

import { KendoColumnDefinition, CrossRatesModel } from "../../insa-models";
import { InsaService, LocalizeService } from "../../insa-services";
import { appStateProvider } from "../../insa-providers";
import { SharedMethodsModule } from "../../insa-custom-scripts";

@Component({
  selector: "insaweb-crossRates",
  template:
    '<div class="canvas gridResize" id="GenericExRates"><div id="ExRatesGrid" (window:resize)="onResize($event)"></div></div><div class="crossRates-loading"></div>',
})
export class CrossRatesComponent implements AfterViewInit, OnDestroy {
  private crossRatesSubscription;
  private selectedCurrency: string;

  constructor(
    private _appStateProvider: appStateProvider,
    private _insaService: InsaService,
    private _router: Router,
    private _localize: LocalizeService,
  ) {
    this.crossRatesSubscription =
      this._insaService.CrossRatesChangedEvent.subscribe((crossRates) =>
        this.refreshRates(crossRates),
      );
  }

  private refreshRates(crossRates: CrossRatesModel[]) {
    if (
      crossRates !== undefined &&
      crossRates !== null &&
      crossRates.length > 0
    ) {
      this.selectedCurrency = this._appStateProvider.selectedCurrency.text;
      this.InitKendoGridExRates(this.createExcRatesColumnDefs(), crossRates);
    } else {
      this.selectedCurrency = "";
      this.InitKendoGridExRates([], []);
    }
  }

  private createExcRatesColumnDefs() {
    let columnExcRateDefs = new Array<KendoColumnDefinition>();

    columnExcRateDefs.push(
      new KendoColumnDefinition(
        "CurrShort",
        this._localize.getLocalizedResource("Res1052"),
        "#:CurrShort#",
      ),
    );

    if (
      this._insaService.crossRates[0].RateCol1 !== undefined &&
      this._insaService.crossRates[0].RateCol1 !== null
    ) {
      columnExcRateDefs.push(
        new KendoColumnDefinition(
          "RateCol1",
          this._insaService.crossRates[0].RateCol1,
          "#:RateCol1#",
        ),
      );
    }

    if (
      this._insaService.crossRates[0].RateCol2 !== undefined &&
      this._insaService.crossRates[0].RateCol2 !== null
    ) {
      columnExcRateDefs.push(
        new KendoColumnDefinition(
          "RateCol2",
          this._insaService.crossRates[0].RateCol2,
          "#:RateCol2#",
        ),
      );
    }

    if (
      this._insaService.crossRates[0].RateCol3 !== undefined &&
      this._insaService.crossRates[0].RateCol3 !== null
    ) {
      columnExcRateDefs.push(
        new KendoColumnDefinition(
          "RateCol3",
          this._insaService.crossRates[0].RateCol3,
          "#:RateCol3#",
        ),
      );
    }

    if (
      this._insaService.crossRates[0].RateCol4 !== undefined &&
      this._insaService.crossRates[0].RateCol4 !== null
    ) {
      columnExcRateDefs.push(
        new KendoColumnDefinition(
          "RateCol4",
          this._insaService.crossRates[0].RateCol4,
          "#:RateCol4#",
        ),
      );
    }

    if (
      this._insaService.crossRates[0].RateCol5 !== undefined &&
      this._insaService.crossRates[0].RateCol5 !== null
    ) {
      columnExcRateDefs.push(
        new KendoColumnDefinition(
          "RateCol5",
          this._insaService.crossRates[0].RateCol5,
          "#:RateCol5#",
        ),
      );
    }
    if (
      this._insaService.crossRates[0].RateCol6 !== undefined &&
      this._insaService.crossRates[0].RateCol6 !== null
    ) {
      columnExcRateDefs.push(
        new KendoColumnDefinition(
          "RateCol6",
          this._insaService.crossRates[0].RateCol6,
          "#:RateCol6#",
        ),
      );
    }
    if (
      this._insaService.crossRates[0].RateCol7 !== undefined &&
      this._insaService.crossRates[0].RateCol7 !== null
    ) {
      columnExcRateDefs.push(
        new KendoColumnDefinition(
          "RateCol7",
          this._insaService.crossRates[0].RateCol7,
          "#:RateCol7#",
        ),
      );
    }
    if (
      this._insaService.crossRates[0].RateCol8 !== undefined &&
      this._insaService.crossRates[0].RateCol10 !== null
    ) {
      columnExcRateDefs.push(
        new KendoColumnDefinition(
          "RateCol8",
          this._insaService.crossRates[0].RateCol8,
          "#:RateCol8#",
        ),
      );
    }
    if (
      this._insaService.crossRates[0].RateCol9 !== undefined &&
      this._insaService.crossRates[0].RateCol9 !== null
    ) {
      columnExcRateDefs.push(
        new KendoColumnDefinition(
          "RateCol9",
          this._insaService.crossRates[0].RateCol9,
          "#:RateCol9#",
        ),
      );
    }

    if (
      this._insaService.crossRates[0].RateCol10 !== undefined &&
      this._insaService.crossRates[0].RateCol10 !== null
    ) {
      columnExcRateDefs.push(
        new KendoColumnDefinition(
          "RateCol10",
          this._insaService.crossRates[0].RateCol10,
          "#:RateCol10#",
        ),
      );
    }

    this.setPropertiesForExRatesGrid(columnExcRateDefs);
    if (this._router.url === "/home") {
      return this.setExRatesList(columnExcRateDefs);
    } else if (this._router.url === "/crossRates") {
      return columnExcRateDefs;
    }
  }

  private setPropertiesForExRatesGrid(kendoColumn) {
    for (let i = 0; i < kendoColumn.length; i++) {
      if (kendoColumn[i].field === "CurrShort") {
        kendoColumn[i].headerAttributes = {
          style: "text-transform:none;",
        };
      } else {
        kendoColumn[i].attributes = { style: "text-align:right;" };
        kendoColumn[i].headerAttributes = {
          style: "text-align:right;text-transform:none; ",
        };
      }
    }
  }

  private InitKendoGridExRates(columnDefs, griddata) {
    let dataSourceOptions: kendo.data.DataSourceOptions = {};
    dataSourceOptions.data = griddata;
    let dataSource: kendo.data.DataSource = new kendo.data.DataSource(
      dataSourceOptions,
    );

    let crossRatesOptions: kendo.ui.GridOptions = {};
    crossRatesOptions.dataSource = dataSource;
    crossRatesOptions.selectable = true;
    //crossRatesOptions.height = '100%'
    crossRatesOptions.reorderable = true;
    crossRatesOptions.resizable = true;
    crossRatesOptions.pageable = false;
    if (this._router.url == "/home") {
      crossRatesOptions.scrollable = false;
    } else if (this._router.url == "/crossRates") {
      crossRatesOptions.scrollable = true;
    }
    crossRatesOptions.noRecords = {
      template: SharedMethodsModule.noDataTemplate(),
    };
    crossRatesOptions.columns = columnDefs;
    $("#ExRatesGrid").kendoGrid(crossRatesOptions);

    let crossRatesGrid: kendo.ui.Grid = $("#ExRatesGrid").data("kendoGrid");
    if (crossRatesGrid !== undefined) {
      crossRatesGrid.setDataSource(dataSource);
      let data = crossRatesGrid.dataSource.at(0);
      if (crossRatesGrid.dataSource !== null) {
        crossRatesGrid.dataSource.remove(data);
      }
      crossRatesGrid.destroy();
      $("#ExRatesGrid").empty().kendoGrid(crossRatesOptions);

      if (griddata.length < 1) {
        $("#ExRatesGrid .k-grid-header").hide();
      }
    } else {
      // do not throw errors - grid doesn't exist when logging out
      // console.log('crossRatesGrid does not exist!!!');
      // throw('CROSS RATES ERROR');
    }
  }

  private setExRatesList(kendoColumn) {
    let columnExcRateDefs = [];
    for (let i = 0; i < kendoColumn.length; i++) {
      if (kendoColumn[i].field === "CurrShort") {
        columnExcRateDefs.push(kendoColumn[i]);
      }
      if (kendoColumn[i].title !== null && kendoColumn[i].title !== undefined) {
        if (kendoColumn[i].title.trim() === this.selectedCurrency) {
          columnExcRateDefs.push(kendoColumn[i]);
        }
      }
    }
    return columnExcRateDefs;
  }

  private onResize(event) {
    let crossRatesGrid: kendo.ui.Grid = $("#ExRatesGrid").data("kendoGrid");
    if (crossRatesGrid !== undefined) {
      crossRatesGrid.options.height = $(".gridResize").height();
      crossRatesGrid.resize();
    }
  }

  ngAfterViewInit() {
    kendo.ui.progress(
      $(".crossRates-loading"),
      this._appStateProvider.fetchingCrossRates,
    );
    this.refreshRates(this._insaService.crossRates);
  }

  ngOnDestroy() {
    this.crossRatesSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-grids/cross-rates.component.ts